import { useEffect, useRef } from 'react'
import type { ReactNode } from 'react'

/**
 * Un contenitore che, appena compare, si porta **in vista**.
 *
 * Il modulo «Pianifica» si apriva in fondo al riquadro della famiglia — sotto
 * tutte le tessere — e con molti tipi finiva fuori dallo schermo: chi cliccava
 * non vedeva succedere niente e concludeva che il pulsante non funzionava. Ora
 * il modulo sta subito sotto la tessera cliccata e, se comunque non è visibile,
 * la pagina scorre fino a lui.
 */
export function ModuloInVista({ className, children }: { className?: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [])
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}
